import React from 'react'
import { Grid, Box, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Tr from 'translations/Translations';
import { connect } from 'react-redux'
import Endpoints from "../../../constants/Endpoints";


const style = theme => ({
	root: {
		width: 'unset',
		marginLeft: theme.spacing(2),
	},
	linkText: {
		color: 'inherit',
		textDecoration: 'none',
	}
})

function Profile({
	classes,
	user = { login: '' },
	userProfile
}) {

	return (
		<Grid
			container
			direction='column'
			className={classes.root}
			alignItems='center'
		>
			<Grid item>
				<Typography component="div" variant='body1' >
					<Box fontWeight="fontWeightBold">
						{user.login}
					</Box>
				</Typography>
			</Grid>
			<Grid item>
				<Typography
					variant='caption'
					component='a'
					href={userProfile?.link?.url ? userProfile.link.url : Endpoints.SERVER_URL}
					className={classes.linkText}
				>
					{Tr('show_profile')}
				</Typography>
			</Grid>
		</Grid>
	)
}

export default connect((state) => ({
	user: state.resources.userData,
	userProfile: state.resources.userProfile,
}), {

})(withStyles(style)(Profile));
